export const PREVIEW_MODE_ERROR_MESSAGE =
  'You cannot complete a Connect session while in Preview mode.';
